module.exports = __webpack_public_path__ + "media/images/searchtop-2-c2d5a28a46fc47aa2d55395e076779e0.png";